// src/components/WhatsNewModal.js

import React from 'react';

function WhatsNewModal({ isOpen, onClose, version, changes }) {
  if (!isOpen) return null;

  const features = changes || [];

  return (
    <div
      className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm z-[200] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Banner */}
        <div className="bg-gradient-to-br from-indigo-600 to-purple-600 px-6 pt-8 pb-10 text-center relative overflow-hidden">
          <div className="absolute -top-6 -right-6 w-32 h-32 bg-white/10 rounded-full" />
          <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-white/10 rounded-full" />
          <div className="relative">
            <span className="text-5xl">🎉</span>
            <h2 className="mt-3 text-2xl font-black text-white font-manrope tracking-tight">
              FinControl {version}
            </h2>
            <p className="mt-1 text-indigo-200 text-sm font-medium">
              Sua maior atualização chegou!
            </p>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4">
            O que há de novo
          </p>
          <ul className="space-y-3">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-3 text-sm text-slate-700">
                <span className="text-base leading-snug">{feature.split(' ')[0]}</span>
                <span className="leading-snug">{feature.split(' ').slice(1).join(' ')}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3.5 rounded-xl font-bold font-manrope shadow-lg shadow-indigo-500/30 hover:opacity-90 hover:-translate-y-0.5 transition-all"
          >
            Explorar novidades →
          </button>
        </div>
      </div>
    </div>
  );
}

export default WhatsNewModal;
